import { connect } from 'react-redux';
import ObjectPhoto from './ObjectPhoto';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { WithObjectComponentHOC } from '../../HOC/WithObjectComponentHOC';
import { WithAppendHeaderAndFooterHOC } from '../../HOC/WithAppendHeaderAndFooterHOC';
import { WithAppendSidebarHOC } from '../../HOC/WithAppendSidebarHOC';
import { savePagePhotos } from '../../globalState/object/actions';
import { getBaseUrlSelector, getUserRoleSelector, } from '../../globalState/app/selectros';
import { WithSavingSnackBar } from '../../HOC/WithSavingSnackBar';
import { getPhotosFromDB, getRejectedPhotosFromDB } from './selector';

const mapStateToProps = (state) => ({
  headerSubtitle: true,
  photosToDB: getPhotosFromDB(state),
  rejectedPhotosToDB: getRejectedPhotosFromDB(state),
  userRole: getUserRoleSelector(state),
  baseUrl: getBaseUrlSelector(state),
});


export default compose(
  connect(mapStateToProps, {
    savePagePhotos,
  }),
  withRouter,
  WithObjectComponentHOC,
  WithAppendHeaderAndFooterHOC,
  WithAppendSidebarHOC,
  WithSavingSnackBar
)(ObjectPhoto);
